<p-toast key="technical"></p-toast>
<p-toast key="deleteTechnical"></p-toast>

<header class="technical-header">
  <div class="technical-header__identity">
    <div class="technical-header__icon" aria-hidden="true">
      <i class="pi pi-cog"></i>
    </div>

    <div class="technical-header__copy">
      <h1>Technical Records</h1>
      <p>Maintenance history <span>&middot;</span> Select a vehicle</p>
    </div>
  </div>

  <div class="technical-header__status" aria-label="Select a vehicle">
    <span
      class="technical-header__status-dot"
      [class.technical-header__status-dot--waiting]="!selectedVehicle"
    ></span>
    <span>{{ selectedVehicle?.vehicle_reference || "Vehicle required" }}</span>
  </div>
</header>
<section class="technical-actionbar" aria-label="Vehicle technical actions">
  <div class="technical-actionbar__context">
    <span class="technical-actionbar__eyebrow">Vehicle workspace</span>
    <strong>
      {{ selectedVehicle?.vehicle_reference || "No vehicle selected" }}
    </strong>
    <span>
      {{
        selectedVehicle
          ? "Review issues, records, and service history"
          : "Select a vehicle to open its technical workspace"
      }}
    </span>
  </div>

  <div class="technical-actionbar__controls">
    <div class="technical-actionbar__field">
      <label for="technicalVehicleSelect">Vehicle</label>
      <p-dropdown
        inputId="technicalVehicleSelect"
        [options]="vehicles"
        [ngModel]="selectedVehicle"
        dataKey="id"
        optionLabel="vehicle_reference"
        placeholder="Select a vehicle"
        styleClass="technical-actionbar__dropdown"
        [filter]="true"
        filterBy="vehicle_reference"
        (onChange)="onVehicleSelect($event)"
        appendTo="body"
      >
      </p-dropdown>
    </div>

    <div class="technical-actionbar__actions">
      <button
        pButton
        type="button"
        label="Deselect Vehicle"
        icon="pi pi-times"
        class="p-button-sm p-button-text p-button-danger"
        [disabled]="!selectedVehicle"
        (click)="deselectVehicle()"
      ></button>

      <button
        pButton
        type="button"
        label="Add Technical Record"
        icon="pi pi-plus"
        class="p-button-sm p-button-outlined"
        [disabled]="!selectedVehicle"
        (click)="openCreateTechnicalRecordDialog()"
      ></button>
    </div>
  </div>
</section>
<div class="technical-page" *ngIf="!selectedVehicle; else showVehicle">
  <div class="technical-content">
    <div class="grid">
      <div class="col-12">
        <div
          class="block overflow-hidden surface-card shadow-1 border-round w-full p-4"
          style="max-width: 100vw"
        >
        <p-table
        dataKey="id"
        #mainTable
        [value]="allTechnicalRecords"
        [rowHover]="true"
        responsiveLayout="scroll"
        scrollHeight="75vh"
        scrollDirection="both"
        [scrollable]="true"
        [responsive]="true"
        [paginator]="true"
        [lazy]="true"
        (onLazyLoad)="loadTechnicalRecords($event)"
        [rows]="technicalPageSize"
        [first]="currentPage"
        [totalRecords]="totalRecords"
        [rowsPerPageOptions]="[25, 50, 100]"
        [loading]="loading"
        [tableStyle]="{ 'min-width': '60rem' }"
        styleClass="app-table p-datatable-sm lg:p-datatable-md"
      >
            <ng-template pTemplate="caption">
              <div class="tr-caption">
                <!-- Top row: keyword + actions -->
                <div class="tr-caption__toprow">
                  <span class="p-input-icon-left p-input-icon-right tr-caption__search">
                    <i class="pi pi-search"></i>
                    <input
                      pInputText
                      type="text"
                      [value]="keyword"
                      (input)="filterGlobal($event)"
                      placeholder="Keyword search…"
                    />
                    <i
                      *ngIf="
                        keyword ||
                        activeFilters.length ||
                        pendingRecordType !== 'all'
                      "
                      class="pi pi-times"
                      style="cursor:pointer"
                      (click)="clearFilters()"
                    ></i>
                  </span>

                  <div class="tr-caption__actions">
                    <button
                      pButton
                      type="button"
                      [label]="showFilterPanel ? 'Hide Filters' : 'Filters'"
                      [icon]="showFilterPanel ? 'pi pi-times' : 'pi pi-filter'"
                      class="p-button-sm p-button-outlined"
                      [class.p-button-primary]="activeFilters.length > 0"
                      (click)="showFilterPanel = !showFilterPanel"
                    ></button>

                    <button
                      pButton
                      type="button"
                      label="Download Excel"
                      icon="pi pi-file-excel"
                      class="p-button-sm p-button-success"
                      [loading]="downloadingExcel"
                      (click)="downloadExcel()"
                    ></button>
                  </div>
                </div>

                <!-- Active filter chips -->
                <div
                  class="tr-caption__chips"
                  *ngIf="
                    activeFilters.length > 0 || pendingRecordType !== 'all'
                  "
                >
                  <div class="tr-caption__logic" *ngIf="activeFilters.length > 1">
                    <p-selectButton
                      [options]="[{ label: 'AND', value: 'AND' }, { label: 'OR', value: 'OR' }]"
                      [(ngModel)]="filterLogic"
                      (onChange)="onFilterLogicChange()"
                      optionLabel="label"
                      optionValue="value"
                    ></p-selectButton>
                  </div>

                  <p-chip
                    *ngIf="pendingRecordType !== 'all'"
                    [label]="'Records: ' + selectedRecordTypeLabel"
                    [removable]="true"
                    (onRemove)="clearRecordTypeFilter()"
                    styleClass="tr-filter-chip"
                  ></p-chip>

                  <p-chip
                    *ngFor="let f of activeFilters; let i = index"
                    [label]="f.fieldLabel + ' ' + f.operatorLabel + ' ' + f.value"
                    [removable]="true"
                    (onRemove)="removeFilter(i)"
                    styleClass="tr-filter-chip"
                  ></p-chip>

                  <button
                    pButton
                    type="button"
                    label="Clear all"
                    icon="pi pi-trash"
                    class="p-button-sm p-button-text p-button-danger"
                    (click)="clearFilters()"
                  ></button>
                </div>

                <!-- Filter builder panel -->
                <div class="tr-filter-panel" *ngIf="showFilterPanel">
                  <div class="tr-filter-panel__row">
                    <p-dropdown
                      [options]="filterableFields"
                      [(ngModel)]="pendingField"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Field"
                      styleClass="tr-filter-panel__field"
                      appendTo="body"
                    ></p-dropdown>

                    <p-dropdown
                      [options]="filterOperators"
                      [(ngModel)]="pendingOperator"
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Operator"
                      styleClass="tr-filter-panel__op"
                      appendTo="body"
                    ></p-dropdown>

                    <p-dropdown
                      placeholder="Record source"
                      [options]="recordTypeOptions"
                      [(ngModel)]="pendingRecordType"
                      optionLabel="label"
                      optionValue="value"
                      styleClass="tr-filter-panel__record-type"
                      (onChange)="onRecordTypeChange()"
                      appendTo="body"
                    ></p-dropdown>

                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="pendingValue"
                      placeholder="Value"
                      class="tr-filter-panel__value"
                      (keyup.enter)="addFilter()"
                    />

                    <button
                      pButton
                      type="button"
                      label="Add Filter"
                      icon="pi pi-plus"
                      class="p-button-sm p-button-primary"
                      [disabled]="!pendingField || !pendingOperator || !pendingValue.trim()"
                      (click)="addFilter()"
                    ></button>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="vehicle_reference">
                  <div class="flex align-items-center">
                    <span>Vehicle Reference</span>
                    <p-sortIcon field="vehicle_reference"></p-sortIcon>
                  </div>
                </th>
                <th pSortableColumn="record_type">
                  <div class="flex align-items-center">
                    <span>Record Type</span>
                    <p-sortIcon field="record_type"></p-sortIcon>
                  </div>
                </th>
                <th pSortableColumn="date_completed">
                  <div class="flex align-items-center">
                    <span>Date Completed</span>
                    <p-sortIcon field="date_completed"></p-sortIcon>
                  </div>
                </th>
                <th pSortableColumn="odometer">
                  <div class="flex align-items-center">
                    <span>Odometer</span>
                    <p-sortIcon field="odometer"></p-sortIcon>
                  </div>
                </th>
                <th>Jobs</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-record>
              <tr style="cursor: pointer" (click)="showSelectedVehicle(record)">
                <td>{{ record.vehicle_reference }}</td>
                <td><span class="record-tag">{{ record.record_type }}</span></td>
                <td class="mono-cell">{{ record.date_completed }}</td>
                <td class="mono-cell">{{ record.odometer }}</td>

                <td>
                  <div class="job-chip-list">
                    <div
                      *ngFor="let job of record.technical_record_jobs"
                      class="job-chip"
                    >
                      <span class="job-chip__title">
                        {{ job.job_description }}
                      </span>

                      <span class="job-chip__remark" *ngIf="job.remarks">
                        {{ job.remarks }}
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="technicalColumns.length">
                  <div
                    class="flex align-items-center justify-content-center py-4"
                  >
                    <p-progressBar
                      *ngIf="isLoading"
                      mode="indeterminate"
                      styleClass="w-full"
                    ></p-progressBar>

                    <span *ngIf="!isLoading" class="text-600">
                      No technical records found
                    </span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #showVehicle>
  <div class="technical-page">
    <div class="technical-content">
      <div class="grid">
        <!-- Vehicle side bar -->
        <div class="col-12 lg:col-4 xl:col-3">
          <aside class="vehicle-details-panel">
            <div class="vehicle-details-panel__header">
              <div>
                <span class="vehicle-details-panel__eyebrow">
                  Vehicle Details
                </span>
                <h2>
                  {{ selectedVehicle.vehicle_reference || "Selected vehicle" }}
                </h2>
              </div>

              <span class="vehicle-details-panel__badge">Selected</span>
            </div>

            <div class="vehicle-detail-list">
              <div class="vehicle-detail-row">
                <span>Chassis No</span>
                <strong>
                  {{ selectedVehicle.chassis_no }}
                </strong>
              </div>

              <div class="vehicle-detail-row">
                <span>Year Model</span>
                <strong>
                  {{ selectedVehicle.year_model }}
                </strong>
              </div>

              <div class="vehicle-detail-row">
                <span>Model</span>
                <strong>
                  {{ selectedVehicle.model }}
                </strong>
              </div>

              <div class="vehicle-detail-row">
                <span>Engine No</span>
                <strong>
                  {{ selectedVehicle.engine_no }}
                </strong>
              </div>

              <div class="vehicle-detail-row">
                <span>In Service</span>
                <strong>
                  {{ selectedVehicle.date_inservice || "Not captured" }}
                </strong>
              </div>

              <div class="vehicle-detail-row">
                <span>Service Interval</span>
                <strong>
                  {{ selectedVehicle.service_interval || "Not captured" }}
                </strong>
              </div>
            </div>

            <div class="vehicle-metrics-grid">
              <div class="vehicle-metric-card">
                <span>Latest odometer</span>
                <strong>{{ latestOdometer }}</strong>
              </div>

              <div class="vehicle-metric-card">
                <span>Active issues</span>
                <strong>{{ issueTotalRecords }}</strong>
              </div>

              <div class="vehicle-metric-card">
                <span>Records</span>
                <strong>{{ vehicleTechnicalTotal }}</strong>
              </div>

              <div class="vehicle-metric-card">
                <span>Last record</span>
                <strong>{{ lastRecordDate }}</strong>
              </div>
            </div>

            <section class="vehicle-insight-card">
              <div class="vehicle-insight-card__header">
                <h3>Record types</h3>
                <span>{{ vehicleTechnicalTotal }} total</span>
              </div>

              <ng-container *ngIf="hasRecordMixChart; else noRecordMixChart">
                <div class="vehicle-chart vehicle-chart--doughnut">
                  <p-chart
                    type="doughnut"
                    [data]="vehicleRecordMixChartData"
                    [options]="vehicleRecordMixChartOptions"
                  ></p-chart>

                  <div class="vehicle-chart__center">
                    <strong>{{ vehicleTechnicalTotal }}</strong>
                    <span>Records</span>
                  </div>
                </div>

                <div class="vehicle-chart-legend">
                  <div
                    class="vehicle-chart-legend__item"
                    *ngFor="let item of vehicleRecordTypeLegend"
                  >
                    <span
                      class="vehicle-chart-legend__dot"
                      [style.background-color]="item.color"
                    ></span>
                    <span>{{ item.label }}</span>
                    <strong>{{ item.value }}</strong>
                  </div>
                </div>
              </ng-container>

              <ng-template #noRecordMixChart>
                <div class="vehicle-insight-card__empty">
                  No technical records yet
                </div>
              </ng-template>
            </section>
          </aside>
        </div>

        <!-- technical table workspace -->
        <div class="col-12 lg:col-8 xl:col-9">
          <div
            class="block overflow-hidden surface-card shadow-1 border-round w-full p-4"
            style="max-width: 100vw"
          >
            <p-table
              #dt
              [value]="issueData"
              [rowHover]="true"
              responsiveLayout="scroll"
              scrollHeight="75vh"
              scrollDirection="both"
              [scrollable]="true"
              [responsive]="true"
              [rows]="issueRows"
              [first]="currentIssuePage"
              [lazy]="true"
              (onLazyLoad)="loadActiveIssues($event)"
              [totalRecords]="issueTotalRecords"
              [loading]="loading"
              [tableStyle]="{ 'min-width': '50rem' }"
              styleClass="app-table p-datatable-sm lg:p-datatable-md"
            >
              <ng-template pTemplate="caption">
                <div
                  class="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-3 py-2"
                >
                  <div class="flex flex-wrap align-items-center gap-2">
                    <ng-container
                      *ngIf="
                        selectedDescription.length > 0;
                        else defaultIssueCaption
                      "
                    >
                      <span class="text-600 text-sm mr-2">
                        {{ selectedDescription.length }} selected
                      </span>

                      <button
                        pButton
                        type="button"
                        icon="pi pi-check"
                        label="Sign off"
                        class="p-button-sm p-button-outlined"
                        (click)="
                          showSignOffModal(
                            selectedDescription,
                            selectedDescription
                          )
                        "
                      ></button>

                      <button
                        pButton
                        type="button"
                        icon="pi pi-pencil"
                        label="Update"
                        class="p-button-sm p-button-text"
                        (click)="showEditActiveIssueModal(selectedDescription)"
                      ></button>

                      <button
                        pButton
                        type="button"
                        icon="pi pi-trash"
                        label="Delete"
                        class="p-button-sm p-button-text p-button-danger"
                        (click)="confirmMultiDelete()"
                      ></button>
                    </ng-container>

                    <ng-template #defaultIssueCaption>
                      <span class="text-800 font-medium">Active Issues</span>
                    </ng-template>
                  </div>

                  <div class="w-full md:w-auto">
                    <span class="p-input-icon-left p-input-icon-right w-full">
                      <i class="pi pi-search"></i>
                      <input
                        pInputText
                        type="text"
                        class="w-full md:w-20rem"
                        [value]="issueFilter"
                        (input)="filterActiveIssues($event)"
                        placeholder="Search keyword"
                      />
                      <i
                        *ngIf="issueFilter"
                        class="pi pi-times"
                        style="cursor:pointer"
                        (click)="clearActiveIssueFilter()"
                      ></i>
                    </span>
                  </div>
                </div>
              </ng-template>

              <ng-template pTemplate="header">
                <tr>
                  <th
                    *ngFor="let col of issueColumns"
                    [pSortableColumn]="col.field"
                  >
                    <div class="flex align-items-center">
                      <span>{{ col.header }}</span>
                      <p-sortIcon [field]="col.field"></p-sortIcon>
                    </div>
                  </th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-issue>
                <tr (click)="handleCellClick($event)">
                  <td>
                    <div
                      class="flex flex-column gap-2"
                      (click)="handleCellClick($event)"
                    >
                      <ng-container
                        *ngFor="let description of issue.descriptions"
                      >
                        <div
                          class="flex align-items-center justify-content-between gap-2 border-1 surface-border border-round px-3 py-2"
                        >
                          <div
                            class="flex align-items-center gap-2 flex-1 min-w-0"
                          >
                            <p-checkbox
                              [value]="description"
                              [(ngModel)]="selectedDescription"
                              (click)="handleCellClick($event)"
                            ></p-checkbox>

                            <span
                              class="white-space-nowrap overflow-hidden text-overflow-ellipsis cursor-pointer text-900"
                              (click)="showSignOffModal(issue, description)"
                            >
                              {{ description.description }}
                            </span>
                          </div>

                          <div
                            class="flex align-items-center gap-1 flex-shrink-0"
                          >
                            <button
                              pButton
                              type="button"
                              icon="pi pi-pencil"
                              class="p-button-sm p-button-text"
                              (click)="
                                showEditActiveIssueModal(description);
                                handleCellClick($event)
                              "
                            ></button>

                            <button
                              pButton
                              type="button"
                              icon="pi pi-trash"
                              class="p-button-sm p-button-text p-button-danger"
                              (click)="
                                confirmActiveIssueDelete(description);
                                handleCellClick($event)
                              "
                            ></button>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="2">
                    <div
                      class="flex align-items-center justify-content-center py-4"
                    >
                      <span class="text-800 font-medium text-xl">
                        No active issues
                      </span>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>

            <div class="mt-4">
              <app-table
                [dataConfig]="{ dataType: 'technical' }"
                [selectedVehicle]="selectedVehicle"
              ></app-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<p-confirmDialog #cd>
  <p-footer>
    <div class="flex justify-content-end gap-2">
      <button
        pButton
        type="button"
        label="No"
        class="p-button-text"
        (click)="cd.reject()"
      ></button>
      <button pButton type="button" label="Yes" (click)="cd.accept()"></button>
    </div>
  </p-footer>
</p-confirmDialog>
